import { Component, Input } from '@angular/core';
import _ from 'lodash';
import {
  PartnerListUploadItem,
  CustomerListImportItem
} from '../../../models/private-workshop-response.model';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-access-list-error-log',
  templateUrl: './access-list-error-log.component.html',
  styleUrls: ['./access-list-error-log.component.scss'],
  standalone: true,
  imports: [DialogModule, TableModule]
})
export class AccessListErrorLogComponent {
  @Input() showLogs!: boolean;
  isPartner!: boolean;
  fileImportLog: any;
  isTpidSupporetedForCustomer!: boolean;
  partnerFileImportLog!: PartnerListUploadItem;
  customerFileImportLog!: CustomerListImportItem;

  closePreview(): void {
    this.showLogs = false;
  }

  loadError(
    uploadResult: PartnerListUploadItem | CustomerListImportItem,
    fileType: string,
    tpidSupported: boolean
  ): void {
    this.isTpidSupporetedForCustomer = tpidSupported;
    this.isPartner = fileType == 'Partner' ? true : false;
    if (fileType == 'Customer') {
      this.fileImportLog = uploadResult as CustomerListImportItem;
    } else if (fileType == 'Partner') {
      this.fileImportLog = uploadResult as PartnerListUploadItem;
    }
    this.showLogs = true;
  }

  getIdList(idList: string[]): string {
    if (idList) {
      idList = _.union(idList);
      return idList.length == 0 ? '0' : idList.join(', ');
    } else {
      return '0';
    }
  }
}
